module.exports = __webpack_public_path__ + "static/media/mi_ban_logo.48a49028.jpg";